import React from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaChevronRight
} from "react-icons/fa";
import "../Css/Footer.css";
import logo from "../assets/svk-maid-logo.png";

const Footer = () => {
  // Get current path for active link highlighting
  const currentPath = window.location.pathname;

  return (
    <footer className="main-footer">
      <div className="footer-top">
        <div className="footer-container">
          
          {/* BRAND SECTION */}
          <div className="footer-col brand-col">
            <img src={logo} alt="SVK Maid Service" className="footer-logo" />
            <p className="footer-desc">
              SVK Maid Service is a trusted provider of professional maid services in Mumbai. We provide verified full-time and part-time maids, cooking maids, baby care, patient care, Japa maid and home cleaning services across Mumbai.
            </p>
            <div className="footer-socials">
              <a href="https://www.instagram.com/svk_maid_service/" className="social-btn" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
              <a href="https://www.facebook.com/svkmaidservice" className="social-btn" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
              <a href="https://www.linkedin.com/company/svk-maid-service/" className="social-btn" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
            </div>
          </div>

          {/* QUICK LINKS with Active State */}
          <div className="footer-col">
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-links">
              <li>
                <a href="/" className={currentPath === "/" ? "active" : ""}>
                  <FaChevronRight className="bullet" /> Home
                </a>
              </li>
              <li>
                <a href="/about-us" className={currentPath === "/about-us" ? "active" : ""}>
                  <FaChevronRight className="bullet" /> About Us
                </a>
              </li>
              <li>
                <a href="/blog" className={currentPath === "/blog" ? "active" : ""}>
                  <FaChevronRight className="bullet" /> Blog
                </a>
              </li>
              <li>
                <a href="/faq" className={currentPath === "/faq" ? "active" : ""}>
                  <FaChevronRight className="bullet" /> FAQs
                </a>
              </li>
              <li>
                <a href="/contact" className={currentPath === "/contact" ? "active" : ""}>
                  <FaChevronRight className="bullet" /> Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* SERVICES LINKS with Active State */}
          <div className="footer-col">
            <h4 className="footer-title">Our Services</h4>
            <ul className="footer-links">
              <li>
                <a href="/services/patient-care-service-in-mumbai" className={currentPath === "/services/patient-care" ? "active" : ""}>
                  <FaChevronRight className="bullet" /> Patient Care
                </a>
              </li>
              <li>
                <a href="/services/baby-care-service-in-mumbai" className={currentPath === "/services/baby-care" ? "active" : ""}>
                  <FaChevronRight className="bullet" /> Baby Care
                </a>
              </li>
              <li>
                <a href="/services/house-maid-service-in-mumbai" className={currentPath === "/services/house-maid" ? "active" : ""}>
                  <FaChevronRight className="bullet" /> House Maid
                </a>
              </li>
              <li>
                <a href="/services/cooking-service-in-mumbai" className={currentPath === "/services/cooking" ? "active" : ""}>
                  <FaChevronRight className="bullet" /> Cooking Service
                </a>
              </li>
              <li>
                <a href="/services/driver-service-in-mumbai" className={currentPath === "/services/driver" ? "active" : ""}>
                  <FaChevronRight className="bullet" /> Driver
                </a>
              </li>
              <li>
                <a href="/services/home-cleaning-service-in-mumbai" className={currentPath === "/services/home-cleaning" ? "active" : ""}>
                  <FaChevronRight className="bullet" /> Home Cleaning
                </a>
              </li>
              <li>
                <a href="/services/japa-maid-service-in-mumbai" className={currentPath === "/services/japa-maid" ? "active" : ""}>
                  <FaChevronRight className="bullet" /> Japa Maid
                </a>
              </li>
            </ul>
          </div>

          {/* CONTACT INFO */}
          <div className="footer-col">
            <h4 className="footer-title">Contact Info</h4>
            <ul className="contact-list">
              <li className="address-item">
  <FaMapMarkerAlt className="c-icon" />

  <a
    href="https://maps.app.goo.gl/yEW8FqFS8JXqw27Y6"
    target="_blank"
    rel="noopener noreferrer"
    className="address-link"
  >
    Shreepal Complex, 115, Mahatma Gandhi Rd, near sagar plaza, Kapol wadi, GhatkoparWest, Ghatkopar East, Mumbai, Maharashtra 400086
  </a>
</li>

              <li>
                <FaPhoneAlt className="c-icon" />
                <a href="tel:+919152151180" className="contact-link">+91 91521 51180</a>
              </li>
              <li>
                <FaEnvelope className="c-icon" />
                <a href="mailto:info@svkmaidservice.com" className="contact-link">info@svkmaidservice.com</a>
              </li>
            </ul>
          </div>

        </div>
      </div>

      {/* BOTTOM BAR */}
      <div className="footer-bottom">
        <div className="bottom-container">
          <p>© {new Date().getFullYear()} SVK Maid Services. All Rights Reserved.</p>
          <p>Designed & Developed by <a href="https://markdigital.in/" target="_blank" rel="noopener noreferrer" style={{textDecoration:"none"}}><b style={{color:"gold"}}>MARK DIGITAL</b></a></p>
          <div className="bottom-links">
            <a href="/privacy-policy">Privacy Policy</a>
            <span className="separator">|</span>
            <a href="/terms-conditions">Terms & Conditions</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;